// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.outer[data-v-d4228de6] {\n  width: 100%;\n  background-color: #f9f9f9;\n  padding-top: 64px;\n  padding-bottom: 38px;\n}\n.indexPanel1[data-v-d4228de6] {\n  width: 1200px;\n  height: 440px;\n  margin: 0 auto;\n  margin-bottom: 24px;\n}\n.indexNews[data-v-d4228de6] {\n  margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
